import React from 'react'
import { useForm } from 'react-hook-form'

function DhruvFundPoojan() {
    const { register, handleSubmit, formState: { errors } } = useForm()

    const handleDonationSubmit = (data)=>{
        console.log(data)
    }
    return (
        <div className={`col-12 col-md-9 shadow py-2 px-5`}>
            <img width={'100%'} className='rounded my-2 img-fluid' alt='img' src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQb0BbuDK3VxM5fxKx8GuqxIuoi5YwW1WiDtQ&s' />
            <p>
                जीवन में हर्ष हो या संताप- स्मृति हो या सौभाग्य... जिनेन्द्र प्रभु की शांतिधारा से मिलती है चित्त को शांति विचारों में आती है स्पष्टता। नए मार्ग का सृजन होता है।शांतिधारा से पूरे विश्व का मंगल जुड़ा है और मुक्ति का मार्ग भी श्री महावीर जी क्षेत्र पर शांतिधारा के पुण्यार्जक बनकर आप स्वयं के माध्यम से लाखों भक्तों को शांतिधारा दर्शन के लाभ में सहभागिता निभा सकते हैं और अपनें भावों का समर्पण प्रभु चरणों मे कर सकते हैं अपनी सुविधा अनुसार तिथि-तारीख पर शांतिधारा के पुण्यार्जक बनकर ....भावों से प्रभु को नमन कर कीजिए पुण्य का सृजन। प्रतिदिन प्रातः 7:13 बजे पारस चेनल के माध्यम से अतिशयकारी श्री चाँदनपुर वाले बाबा के पावन दर्शन एवं शांतिधारा लाइव देखने का सौभाग्य पूरे विश्व के भक्त जनों मिलता है, भक्तजन श्री महावीर जी आकर एवं घर बैठे शांतिधारा के माध्यम से प्रभु चरणों मे अपने भाव समर्पण करते हैं । शांतिधारा के लिए विस्तृत जानकारी पं० श्री मुकेश जी शास्त्री से मोबाइल नम्बर 9828280480 पर प्राप्त की जा सकती है
            </p>

            <hr />
            {/* Buttons */}
            <div className='d-flex flex-wrap justify-content-evenly'>
                <button className="btnp glitch btn-sm">
                    <span>परोक्ष शांतिधारा लाइव</span>
                </button>
                <button className="btnp glitch btn-sm">
                    <span>प्रत्यक्ष (स्वयं) शांतिधारा लाइव</span>
                </button>
                <button className="btnp glitch btn-sm">
                    <span>शांतिधारा बोली</span>
                </button>
            </div>

            <div className='text-center mt-3'>
                <p className='fw-bold' style={{ color: '#e79b32', fontSize: '24px' }}>परोक्ष शांतिधारा लाइव</p>
                <p>
                    घर बैठे अपने परिवार के नाम से शांतिधारा कराने हेतु राशि निश्चित है। पारस चैनल पर लाइव एवं जिनवाणी, आदिनाथ चैनल पर पुनः प्रसारण होता है।
                </p>
            </div>



            {/* Form */}

            <div className='container-fluid mx-auto'>
                <div className='row'>
                    <form onSubmit={handleSubmit(data=>handleDonationSubmit())} className='form-control row mx-auto my-5'>
                        <div className='text-center my-3'>
                            <p className='my-2' style={{ fontSize: '24px' }}>परोक्ष शांतिधारा लाइव राशि</p>
                            {errors?.Amount && <p className=''>{errors?.Amount?.message}</p>}
                            <input
                                type='number'
                                className='form-control w-75 mx-auto text-center'
                                {...register('Amount', { required: { value: true, message: 'Donattion Amount is required !!' } })}
                            />
                        </div>
                        <div className='col-12 row'>
                            <div className='col-12 col-md-6'>
                                <label className='form-label ps-2' style={{ fontSize: '14px' }}>
                                    Full Name
                                    {errors?.doner_Name && <span className='text-danger' style={{ fontSize: '12px' }}>{errors?.doner_Name?.message}</span>}
                                </label>
                                <div className='pe-4'>
                                    <input
                                        className='form-control'
                                        type='text'
                                        placeholder='enter your name'
                                        {...register('doner_Name', { required: { value: true, message: 'Your Name is required !!' } })}
                                    />
                                </div>
                            </div>
                            <div className='col-12 col-md-6'>
                                <label className='form-label ps-2' style={{ fontSize: '14px' }}>
                                    Mobile No.
                                    {errors?.doner_Mob && <span className='text-danger' style={{ fontSize: '12px' }}>{errors?.doner_Mob?.message}</span>}
                                </label>
                                <div className='pe-4'>
                                    <input
                                        type='number'
                                        className='form-control'
                                        placeholder='enter your number'
                                        {...register('doner_Mob', { required: { value: true, message: 'Mob.No. is required !!' } })}
                                    />
                                </div>
                            </div>
                            <div className='col-12'>
                                <label className='form-label ps-2' style={{ fontSize: '14px' }}>
                                    Address
                                    {errors?.doner_address && <span className='text-danger' style={{ fontSize: '12px' }}>{errors?.doner_address?.message}</span>}
                                </label>
                                <div className='pe-4'>
                                    <textarea
                                        className='form-control'
                                        {...register('doner_address', { required: { value: true, message: 'enter your address' } })}
                                    />
                                </div>
                            </div>
                            <div className='col-12 row mt-3'>
                                <div className='col-12 col-md-6'>
                                    <label className='form-label ps-2' style={{ fontSize: '14px' }}>
                                        State
                                        {errors?.doner_state && <span className='text-danger' style={{ fontSize: '12px' }}>{errors?.doner_state?.message}</span>}
                                    </label>
                                    <select
                                        className='form-control'
                                        {...register('doner_state', { required: { value: true, message: 'State is required !!' } })}
                                    >
                                        <option>Select a State</option>
                                        <option>Rajasthan</option>
                                        <option>Delhi</option>
                                        <option>Tamilnadu</option>
                                        <option>Madhyapardesh</option>
                                        <option>Jammu</option>
                                        <option>Kashmir</option>
                                    </select>
                                </div>
                                <div className='col-12 col-md-6'>
                                    <label className='form-label ps-2' style={{ fontSize: '14px' }}>
                                        City
                                        {errors?.doner_city && <span className='text-danger' style={{ fontSize: '12px' }}>{errors?.doner_city?.message}</span>}
                                    </label>
                                    <input
                                        type='text'
                                        className='form-control'
                                        placeholder='enter your City'
                                        {...register('doner_city', { required: true, message: 'City is required !!' })}
                                    />
                                </div>


                            </div>
                            <div className='col-12 row mt-3'>

                                <div className='col-12 col-md-6'>
                                    <label className='form-label ps-2' style={{ fontSize: '14px' }}>ID Type (Optional)</label>
                                    <select
                                        className='form-control'
                                        {...register('doner_ID')}
                                    >
                                        <option>Select one</option>
                                        <option>Aadhar Number</option>
                                        <option>PAN Number</option>
                                    </select>
                                </div>
                                <div className='col-12 col-md-6 '>
                                    <label className='form-label ps-2' style={{ fontSize: '14px' }}>ID Proof No (optional)</label>
                                    <input
                                        className='form-control'
                                        type='text'
                                        placeholder='ID Proof No (optional)'
                                        {...register('doner_ID_No')}
                                    />
                                </div>
                            </div>

                            <div className='col-12 row mt-3'>
                                <div className='col-12 col-md-6'>
                                    <label className='form-label ps-2' style={{ fontSize: '14px' }}>
                                        Shanti Dhara Date
                                        {errors?.donation_date && <span className='text-danger' style={{ fontSize: '12px' }}>{errors?.donation_date?.message}</span>}
                                    </label>
                                    <input
                                        type='date'
                                        className='form-control'
                                        {...register('donation_date', { required: { value: true, message: 'Date is required !!' } })}
                                    />
                                </div>
                                <div className='col-12 col-md-6'>
                                    <label className='form-label ps-2' style={{ fontSize: '14px' }}>Occasion</label>
                                    <textarea
                                        className='form-control'
                                        rows={5}
                                        placeholder='type max 200 charector only'
                                        {...register('doner_Occasion')}
                                    />
                                </div>
                            </div>
                            <div className='col-6 d-flex gap-3 mb-3 mt-3'>
                                <button className='btn btn-sm btn-outline-warning'>DONATE & PAY</button>
                                <button className='btn btn-sm btn-outline-secondary'>Reset</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default DhruvFundPoojan
